/* GENERATED by scripts/gen-data.mjs — film scene "f-bus" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_BUS: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "u",
      "x": 14,
      "y": 124,
      "w": 110,
      "h": 56,
      "lKey": "films:f-bus.items.u.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "u",
      "to": "lv"
    },
    {
      "k": "box",
      "id": "lv",
      "x": 150,
      "y": 124,
      "w": 124,
      "h": 56,
      "lKey": "films:f-bus.items.lv.l",
      "sKey": "films:f-bus.items.lv.s"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "lv",
      "to": "log"
    },
    {
      "k": "frame",
      "id": "bus",
      "x": 302,
      "y": 28,
      "w": 150,
      "h": 248,
      "lKey": "films:f-bus.items.bus.l"
    },
    {
      "k": "box",
      "id": "log",
      "x": 316,
      "y": 96,
      "w": 122,
      "h": 76,
      "lKey": "films:f-bus.items.log.l",
      "sKey": "films:f-bus.items.log.s"
    },
    {
      "k": "box",
      "id": "c1",
      "x": 488,
      "y": 36,
      "w": 138,
      "h": 46,
      "lKey": "films:f-bus.items.c1.l"
    },
    {
      "k": "box",
      "id": "c2",
      "x": 488,
      "y": 96,
      "w": 138,
      "h": 46,
      "lKey": "films:f-bus.items.c2.l"
    },
    {
      "k": "box",
      "id": "c3",
      "x": 488,
      "y": 156,
      "w": 138,
      "h": 46,
      "lKey": "films:f-bus.items.c3.l"
    },
    {
      "k": "box",
      "id": "c4",
      "x": 488,
      "y": 216,
      "w": 138,
      "h": 46,
      "lKey": "films:f-bus.items.c4.l"
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "log",
      "to": "c1",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w4",
      "from": "log",
      "to": "c2",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w5",
      "from": "log",
      "to": "c3",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w6",
      "from": "log",
      "to": "c4",
      "dash": true
    }
  ],
  "steps": [
    {
      "on": [
        "u",
        "lv",
        "w1"
      ],
      "hot": [
        "lv",
        "w1"
      ],
      "capKey": "films:f-bus.steps.0.cap"
    },
    {
      "on": [
        "u",
        "lv",
        "w1",
        "bus",
        "log",
        "w2"
      ],
      "hot": [
        "log",
        "w2"
      ],
      "capKey": "films:f-bus.steps.1.cap"
    },
    {
      "on": [
        "bus",
        "log",
        "c1",
        "w3"
      ],
      "hot": [
        "c1",
        "w3"
      ],
      "capKey": "films:f-bus.steps.2.cap"
    },
    {
      "on": [
        "bus",
        "log",
        "c1",
        "w3",
        "c2",
        "w4"
      ],
      "hot": [
        "c2",
        "w4"
      ],
      "capKey": "films:f-bus.steps.3.cap"
    },
    {
      "on": [
        "bus",
        "log",
        "c1",
        "w3",
        "c2",
        "w4",
        "c3",
        "w5",
        "c4",
        "w6"
      ],
      "hot": [
        "c3",
        "c4"
      ],
      "capKey": "films:f-bus.steps.4.cap"
    }
  ]
};
